import { render, staticRenderFns } from "./b2bJobInfo.vue?vue&type=template&id=79432e6a"
import script from "./b2bJobInfo.vue?vue&type=script&lang=js"
export * from "./b2bJobInfo.vue?vue&type=script&lang=js"
import style0 from "./b2bJobInfo.vue?vue&type=style&index=0&id=79432e6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports